
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.36 16l1.14 2.65v3.85h-1v-1.09a1.63 1.63 0 01-.33.077L8 21.5H4.5a1.663 1.663 0 01-.337-.043L4 21.41v1.09H3v-3.85L4.14 16h4.22zm.14 3H4v1a.5.5 0 00.41.492l.09.008H8a.5.5 0 00.492-.41L8.5 20v-1zm11.9-8.903c.094.42.13 1.01.106 1.775L20.5 12a8.5 8.5 0 01-8.5 8.5l-.193-.002-.193-.007.045-.999a7.501 7.501 0 007.776-6.499h-.858l1.823-2.896zM7.71 17H4.79l-.42 1h3.76l-.42-1zM12 3.5c.877 0 1.736.133 2.556.391l.14.048.05.017-.183.993A7.485 7.485 0 0012 4.5a7.5 7.5 0 00-7.498 7.339l.868-.14L4 15c-.117-.28-.216-.663-.297-1.147l.066.276A8.5 8.5 0 0112 3.5zm0 8a2.4 2.4 0 012.312 1.757l.346 1.243H9.342l.346-1.243a2.405 2.405 0 012.133-1.75zm0 1l-.117.005a1.4 1.4 0 00-1.232 1.02l.008-.025h2.681l-.033-.102a1.402 1.402 0 00-1.174-.892L12 12.5zm0-4a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 8.5zm0 1a.5.5 0 100 1 .5.5 0 000-1zM19.512 2v1.499l2.302.001v1h-4.346a.522.522 0 00-.094 1.036l.094.008h2.987a1.49 1.49 0 01.143 2.974l-.143.007-.943-.001v1.293h-1V8.524H16v-1h4.455a.49.49 0 00.088-.972l-.088-.008h-2.987a1.522 1.522 0 01-.139-3.038l.139-.006 1.044-.001V2h1z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    